// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"95":"2b3bf66b","137":"0ca4c041","141":"00d43832","346":"f40327a6","858":"346184ee"}[chunkId] + ".css";
};